import { gql } from "@apollo/client";

export const UPDATE_TIP_MENU = gql`
  mutation UpdateTipMenu($updateTipMenuInput: UpdateTipMenuInput) {
    updateTipMenu(updateTipMenu: $updateTipMenuInput) {
      broadcaster
      id
      name
      tipMenuItems {
        amount
        id
        name
        tipMenu
      }
    }
  }
`;

export const ADD_TIP_MENU = gql`
  mutation createTipMenu($createTipMenuInput: CreateTipMenuInput) {
    createTipMenu(createTipMenuInput: $createTipMenuInput) {
      broadcaster
      id
      name
    }
  }
`;

export const DELETE_TIP_MENU = gql`
  mutation deleteTipMenu($tipMenu: String!) {
    deleteTipMenu(tipMenu: $tipMenu)
  }
`;

export const DUPLICATE_TIP_MENU = gql`
  mutation duplicateTipMenu($tipMenu: String!) {
    duplicateTipMenu(tipMenu: $tipMenu) {
      broadcaster
      id
      name
      isActive
    }
  }
`;

export const COPY_TIP_MENU_ITEM = gql`
  mutation copyTipMenuItem($input: CopyTipMenuItemInput!) {
    copyTipMenuItem(input: $input) {
      id
      name
      amount
      tipMenu
    }
  }
`;

export const SET_ACTIVE_TIP_MENUS = gql`
  mutation setActiveTipMenus($tipMenus: [String!]!) {
    setActiveTipMenus(tipMenus: $tipMenus)
  }
`;
